import React, { useContext, useState } from "react";
import Typewriter from "typewriter-effect";
import { NavLink } from "react-router-dom";
import { ThemeContext } from "../../context";
import Toggle from "../toggle/Toggle";
import { MenuList } from "./MenuList";
import "./navbar.css";

const Navbar = () => {
  const theme = useContext(ThemeContext);
  const dark = theme.state.darkMode;

  const [clicked, setClicked] = useState(false);

  const menuList = MenuList.map(({ title, url }, index) => {
    return (
      <li key={index} style={{ color: dark ? "white" : "black" }}>
        <NavLink
          to={url}
          activeClassName="active"
          style={{ color: dark ? "white" : "black" }}
        >
          {title}
        </NavLink>
      </li>
    );
  });

  const handleClick = () => {
    setClicked(!clicked);
  };

  return (
    <nav
      style={{
        backgroundColor: dark ? "#222" : "white",
        color: dark ? "white" : "black",
        boxShadow: "0px 4px 9px 1px rgba(168,168,168,0.75)",
        webkitBoxShadow: "0px 4px 9px 1px rgba(168,168,168,0.75)",
        mozBoxShadow: "0px 4px 9px 1px rgba(168,168,168,0.75)",
      }}
    >
      <div className="logo">
        <Toggle />
      </div>
      <div className="typewriter" style={{ color: dark ? "white" : "black" }}>
        <Typewriter
          options={{
            strings: ["Welcome to my site!"],
            autoStart: true,
            loop: true,
          }}
        />
      </div>
      <div className="menu-icon" onClick={handleClick}>
        <i className={clicked ? "fas fa-times" : "fas fa-bars"}></i>
      </div>
      <ul
        onClick={handleClick}
        className={clicked ? "menu-list" : "menu-list close"}
      >
        {menuList}
      </ul>
    </nav>
  );
};

export default Navbar;
